import React from "react";
import { Styled } from "./styles";
import { Table } from "@/components/product";
import { withErrorBoundary } from "@/components/hoc";

const Products: React.FC = () => {
    return (
        <Styled.Container>
            <Table />
        </Styled.Container>
    );
};

export default withErrorBoundary({ component: "Products" })(Products);
